import InfoPOGMassiveUpload from './containers/ShoppingByFamilyMassiveUpload';

export default InfoPOGMassiveUpload;
